/**
 * Returns true when the event target is a text-entry surface (input, textarea,
 * or contenteditable). Keyboard-shortcut handlers skip events routed through
 * these so typing `h` in a name field doesn't toggle the cursor mode.
 */ export function isTextInput(target) {
    if (!(target instanceof HTMLElement)) return false;
    const tag = target.tagName;
    if (tag === "INPUT" || tag === "TEXTAREA") return true;
    return target.isContentEditable;
}

//# sourceMappingURL=isTextInput.js.map